import React from "react";

const Footer: React.FC = () => {
    return (
        <>
            <footer
                className="footer p-2 pb-3 d-flex justify-content-between align-items-center flex-wrap border-top fixed-bottom bg-white"
                style={{ zIndex: "2" }}
                id="footer"
            >
                <div className="container-fluid text-end text-muted font-xs">
                    | All rights reserved © Reviniti
                </div>
            </footer>
        </>
    );
};

export default Footer;
